/**
 * Adjusts SLA thresholds using precomputed deadline timestamps from the server.
 * When *_deadline_at fields are present, converts them to threshold values
 * compatible with evaluateSLAStatus by computing: deadline_at - base_time.
 * FRT and RT use created_at as the base; NRT uses waitingSince (last customer
 * response time) because evaluateSLAStatus computes: waitingSince + nrtThreshold.
 * Falls back to the original threshold when deadline_at is null/absent.
 * @param {Object} appliedSla - The applied SLA object in snake_case
 * @param {number|null} waitingSince - Unix timestamp of last customer message
 * @returns {Object} The applied SLA with adjusted thresholds
 */
export function useSLADeadline(appliedSla, waitingSince = null) {
  if (!appliedSla) return appliedSla;

  const { created_at: createdAt } = appliedSla;
  const nrtBase = waitingSince || createdAt;

  return {
    ...appliedSla,
    sla_first_response_time_threshold:
      appliedSla.sla_frt_deadline_at != null
        ? appliedSla.sla_frt_deadline_at - createdAt
        : appliedSla.sla_first_response_time_threshold,
    sla_next_response_time_threshold:
      appliedSla.sla_nrt_deadline_at != null
        ? appliedSla.sla_nrt_deadline_at - nrtBase
        : appliedSla.sla_next_response_time_threshold,
    sla_resolution_time_threshold:
      appliedSla.sla_rt_deadline_at != null
        ? appliedSla.sla_rt_deadline_at - createdAt
        : appliedSla.sla_resolution_time_threshold,
  };
}
